/* SAFA V20 · barre d'achat : visible une fois le bouton du héro dépassé, masquée sur les offres et le pied de page */
(function () {
  'use strict';
  var bar = document.querySelector('[data-v20-sticky]');
  var cta = document.querySelector('[data-v20-hero-cta]');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;
  var state = { past: false, offers: false, foot: false };
  var link = bar.querySelector('a');
  function render() {
    var on = state.past && !state.offers && !state.foot;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (link) link.tabIndex = on ? 0 : -1;
  }
  new IntersectionObserver(function (e) {
    var en = e[0];
    state.past = !en.isIntersecting && en.boundingClientRect.top < 0;
    render();
  }).observe(cta);
  var offers = document.getElementById('offres');
  if (offers) new IntersectionObserver(function (e) { state.offers = e[0].isIntersecting; render(); }, { rootMargin: '0px 0px -20% 0px' }).observe(offers);
  var foot = document.querySelector('footer, .t-footer');
  if (foot) new IntersectionObserver(function (e) { state.foot = e[0].isIntersecting; render(); }).observe(foot);
})();
/* SAFA V20 · total du panier après codes promo (cart.total_price) */
(function () {
  'use strict';
  function fmt(c) {
    var f = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var n = (Number(c) || 0) / 100, p = n.toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.indexOf('comma') > -1 ? '.' : ' ');
    var v = f.indexOf('no_decimals') > -1 ? p[0] : p[0] + (f.indexOf('amount}}') > -1 && f.indexOf('comma') === -1 ? '.' : ',') + p[1];
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  document.addEventListener('herat:cart-rendered', function (e) {
    var cart = e.detail && e.detail.cart; if (!cart) return;
    var el = document.querySelector('[data-cd-subtotal]'); if (el) el.textContent = fmt(cart.total_price);
  });
})();
